import {
  Divider,
  ListItem,
  ListItemText,
  ListItemTextProps as MUIListItemTextProps
} from '@mui/material'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { TopBarLinkProps } from '../types'

interface ListItemProps extends Partial<Pick<TopBarLinkProps, 'to'>> {
  onClick: () => void
}

type ListItemTextProps = Pick<TopBarLinkProps, 'translationId'> &
  Pick<MUIListItemTextProps, 'classes' | 'inset'>

export interface ListItemWrapperProps {
  icon?: ReactNode
  listItemProps: ListItemProps
  listItemTextProps: ListItemTextProps
  useDivider?: boolean
}

export const ListItemWrapper = ({
  icon,
  listItemProps,
  listItemTextProps,
  useDivider = true
}: ListItemWrapperProps) => {
  const { formatMessage } = useIntl()
  const newListItemProps = {
    ...listItemProps,
    component: listItemProps.to !== undefined ? NavLink : undefined
  }
  const { translationId, ...restOfListItemTextProps } = listItemTextProps
  return (
    <>
      <ListItem button {...newListItemProps}>
        <ListItemText
          primary={formatMessage({
            id: translationId
          }).toUpperCase()}
          {...restOfListItemTextProps}
        />
        {icon}
      </ListItem>
      {useDivider && <Divider />}
    </>
  )
}
